import { useStore } from '@/stores'

export function RecordingBanner(): JSX.Element | null {
  const isRecording = useStore((state) => state.isRecording)
  if (!isRecording) return null

  return (
    <div
      className="bg-red-600/90 text-white px-4 py-2 text-sm text-center border-b border-red-700/50"
      role="status"
      aria-live="polite"
    >
      <span className="font-medium">Recording in progress.</span> Keep this screen
      open — switching apps or receiving a call will stop capture.
    </div>
  )
}
